import React from 'react';

const TermsOfService = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        lineHeight: '1.6',
        color: '#333'
      }}>
        <h1 style={{ fontSize: '32px', marginBottom: '10px', color: '#2c3e50' }}>
          Terms of Service
        </h1>
        <p style={{ color: '#7f8c8d', marginBottom: '30px' }}>
          <strong>DiNiTracker Payment Integration</strong><br />
          Last Updated: January 6, 2026
        </p>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Acceptance of Terms</h2>
          <p>
            By using DiNiTracker Payment Integration, you agree to these terms of service.
            If you do not agree to these terms, please do not use our payment services.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Service Description</h2>
          <p>
            DiNiTracker Payment Integration enables DiNi Wigs LLC to securely process customer payments
            and save payment methods for future use. This service integrates with Clover (Fiserv) to
            provide secure, PCI-compliant payment processing.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>User Responsibilities</h2>
          <p>By using our payment services, you agree to:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>Provide accurate payment information</li>
            <li>Authorize charges to saved payment methods</li>
            <li>Notify us immediately of any unauthorized transactions</li>
            <li>Keep your login credentials secure</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Payment Processing</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>All payments are processed through Clover (Fiserv)</li>
            <li>A $0.50 verification charge may appear when saving a new card (this charge is not captured and will not post to your account)</li>
            <li>By saving a payment method, you authorize us to use it for future transactions related to your orders</li>
            <li>Saved payment methods can be deleted at any time by contacting customer support</li>
            <li>We reserve the right to decline or cancel any transaction for security reasons</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Refunds and Disputes</h2>
          <p>
            Refund requests must be submitted to DiNi Wigs LLC customer service. Approved refunds
            will be processed within 5-10 business days to the original payment method.
          </p>
          <p style={{ marginTop: '15px' }}>
            For payment disputes, please contact us at{' '}
            <a href="mailto:it@diniwigs.com" style={{ color: '#3498db', textDecoration: 'none' }}>
              it@diniwigs.com
            </a>{' '}
            before initiating a chargeback with your card issuer.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Security</h2>
          <p>
            We take security seriously and implement industry-standard measures to protect your payment information:
          </p>
          <ul style={{ marginLeft: '20px' }}>
            <li>All payment data is tokenized and encrypted</li>
            <li>We never store your actual credit card numbers</li>
            <li>All communications use secure HTTPS/TLS encryption</li>
            <li>Our payment processing is PCI DSS compliant through Clover</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Limitation of Liability</h2>
          <p>DiNi Wigs LLC is not liable for:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>Clover or payment processor service outages or technical issues</li>
            <li>Declined transactions due to insufficient funds or card issuer policies</li>
            <li>Delays in payment processing by banks or payment networks</li>
            <li>Unauthorized access to your account due to failure to secure your credentials</li>
          </ul>
          <p style={{ marginTop: '15px' }}>
            Our total liability for any claims arising from your use of the payment service
            shall not exceed the amount of the transaction in question.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Termination</h2>
          <p>
            You may request deletion of your saved payment methods at any time by contacting{' '}
            <a href="mailto:it@diniwigs.com" style={{ color: '#3498db', textDecoration: 'none' }}>
              it@diniwigs.com
            </a>.
            We reserve the right to suspend or terminate your access to payment services
            for violation of these terms or suspicious activity.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Material changes will be communicated
            via email or through our platform. Continued use of our payment services after
            changes constitutes acceptance of the updated terms.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Governing Law</h2>
          <p>
            These terms are governed by the laws of the State of New York, United States of America.
            Any disputes arising from these terms or use of our services shall be resolved in the
            courts of New York.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Contact</h2>
          <p>
            For questions about these terms or our payment services, please contact us:
          </p>
          <p style={{ marginTop: '15px' }}>
            <strong>DiNi Wigs LLC</strong><br />
            Email:{' '}
            <a href="mailto:it@diniwigs.com" style={{ color: '#3498db', textDecoration: 'none' }}>
              it@diniwigs.com
            </a><br />
            Phone: (201) 844-3508
          </p>
        </section>

        <div style={{
          marginTop: '50px',
          paddingTop: '20px',
          borderTop: '1px solid #ecf0f1',
          textAlign: 'center',
          color: '#95a5a6',
          fontSize: '14px'
        }}>
          <p>© 2026 DiNi Wigs LLC. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
